module.exports = __webpack_public_path__ + "static/media/format_underlined.2bd21ffc.svg";